// extracted by mini-css-extract-plugin
export default {"user-icon-dropdown-menu":"UserIconDropdown_user-icon-dropdown-menu__tY8Fh"};